(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  if (!window.__audioEyeFooterBound) {
    window.__audioEyeFooterBound = true;
    document.addEventListener('click', (event) => {
      const target = event.target.closest('[data-open-audioeye]');
      if (!target || typeof window.openAudioEyeToolbar !== 'function') return;
      window.openAudioEyeToolbar(target);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    searchModalIsOpen() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      return Boolean(this.searchModal?.querySelector('details[open]'));
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ((this.predictiveSearch && this.predictiveSearch.isOpen) || this.searchModalIsOpen()) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.searchModalIsOpen()) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-benefits"] && !Shopify.designMode) return;
  try {
    
  const setBenefitsVideoPaused = (media, paused) => {
    const video = media.querySelector('video');
    const toggle = media.querySelector('.lp-benefits__media-toggle');
    const label = toggle ? toggle.querySelector('.visually-hidden') : null;
    if (!video || !toggle || !label) return;

    media.classList.toggle('is-paused', paused);
    toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
    label.textContent = paused ? toggle.dataset.labelPlay : toggle.dataset.labelPause;

    if (paused) {
      video.pause();
      return;
    }

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch((error) => {
        console.error('LP benefits video could not play', error);
        media.classList.add('is-paused');
        toggle.setAttribute('aria-pressed', 'true');
        label.textContent = toggle.dataset.labelPlay;
      });
    }
  };

  const setBenefitsVideoMuted = (media, muted) => {
    const video = media.querySelector('video');
    const sound = media.querySelector('.lp-benefits__media-sound');
    const label = sound ? sound.querySelector('.visually-hidden') : null;
    if (!video || !sound || !label) return;

    video.muted = muted;
    if (!muted) video.volume = 1;
    media.classList.toggle('is-muted', muted);
    sound.setAttribute('aria-pressed', muted ? 'true' : 'false');
    label.textContent = muted ? sound.dataset.labelUnmute : sound.dataset.labelMute;
  };

  const holdBenefitsVideoForReducedMotion = (root) => {
    try {
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('.lp-benefits__media').forEach((media) => {
        const video = media.querySelector('video');
        if (!video || media.dataset.motionReady === 'true') return;

        media.dataset.motionReady = 'true';
        video.autoplay = false;
        video.removeAttribute('autoplay');

        let holding = false;
        const blockAutoplay = () => {
          if (holding || media.dataset.userControlled === 'true') return;
          holding = true;
          setBenefitsVideoPaused(media, true);
          holding = false;
        };

        video.addEventListener('play', blockAutoplay);
        blockAutoplay();
      });
    } catch (error) {
      console.error('LP benefits reduced-motion setup failed', error);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      holdBenefitsVideoForReducedMotion(document);
    });
  } else {
    holdBenefitsVideoForReducedMotion(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    holdBenefitsVideoForReducedMotion(event.target);
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const toggle = target.closest('.lp-benefits__media-toggle');
    if (!toggle) return;

    const media = toggle.closest('.lp-benefits__media');
    const video = media ? media.querySelector('video') : null;
    if (!media || !video) return;

    try {
      media.dataset.userControlled = 'true';
      setBenefitsVideoPaused(media, !video.paused);
    } catch (error) {
      console.error('LP benefits video toggle failed', error);
    }
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const sound = target.closest('.lp-benefits__media-sound');
    if (!sound) return;

    const media = sound.closest('.lp-benefits__media');
    const video = media ? media.querySelector('video') : null;
    if (!media || !video) return;

    try {
      setBenefitsVideoMuted(media, !video.muted);
    } catch (error) {
      console.error('LP benefits video sound toggle failed', error);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
